import { EServicesErrorCode } from 'core/model/enums/error-code.enum';
import { IShoppingCartGroupMessage } from 'core/model/interfaces/shopping-cart.interface';

/**
 * Retrieves the minimum sale message from a list of messages.
 *
 * @param messages - Array of shopping cart group messages.
 * @returns The first message that matches the minimum sale error code, or null if not found.
 */
export const getMinimumSaleMessage = (messages: Array<IShoppingCartGroupMessage>) =>
  messages?.find(message => message.id === EServicesErrorCode.CART_MINIMUM_SALE_AMOUNT_NOT_REACHED) || null;
